import { Hero } from '@/components/Layout/Hero';

export const LandingHero = () => {
  return (
    <Hero
      bgColor='bg-cream'
      h1Content='Embracing Financial Possibilities!!!'
      pContent='We provide the technologies, Innovations and strategies that help you secure your future by embracing financial possibilities through Our Digital Real Estate Ecosystem.'
      page='landing'
      buttonBg='bg-indigo'
    />
  );
};
